/* 布局 */
//前台
import Layout from "@views/layout";

const sacrificehomeRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "sacrificehome/list",
        name: "SACRIFICEHOME",
        meta: {
            title: "云祭祀房间管理",
            keepAlive:true
        },
        component: () => import("@views/business/sacrificehome/index.vue"),
    },
        ],
};

export default sacrificehomeRouter;
